// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LookupSiHaDocumentationStatusRequestModel from '../../model/lookup-si-ha-documentation-status-request-model';
import LookupSiHaDocumentationStatusRequestDTO from '../dto/lookup-si-ha-documentation-status-request-dto';
import dtoSchema from '../schemas/lookup-si-ha-documentation-status-request-schema';

export default abstract class LookupSiHaDocumentationStatusRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LookupSiHaDocumentationStatusRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<LookupSiHaDocumentationStatusRequestDTO>): LookupSiHaDocumentationStatusRequestModel;
  static toModel(dto: DeepPartial<LookupSiHaDocumentationStatusRequestDTO> | undefined | null): LookupSiHaDocumentationStatusRequestModel | undefined;
  static toModel(dto: DeepPartial<LookupSiHaDocumentationStatusRequestDTO> | undefined | null): LookupSiHaDocumentationStatusRequestModel | undefined {
    return dto ? new LookupSiHaDocumentationStatusRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LookupSiHaDocumentationStatusRequestModel> | LookupSiHaDocumentationStatusRequestModel): LookupSiHaDocumentationStatusRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as LookupSiHaDocumentationStatusRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LookupSiHaDocumentationStatusRequestModel, can not map to LookupSiHaDocumentationStatusRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
